import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/TermsOfServicePage.head';
import { TermsOfServicePage } from '@pages/TermsOfServicePage';

export const Route = createFileRoute('/terms-of-service')({
  component: TermsOfServicePage,
  head: () => head,
});
